import { action, createRequestTypes } from '../base';

export const paymentModeActionTypes = {
  GET_PAYMENT_MODES: createRequestTypes('GET_PAYMENT_MODES'),
  CREATE_PAYMENT_MODE: createRequestTypes('CREATE_PAYMENT_MODE'),
  UPDATE_PAYMENT_MODE: createRequestTypes('UPDATE_PAYMENT_MODE'),
  DELETE_PAYMENT_MODE: createRequestTypes('DELETE_PAYMENT_MODE'),
};

/*
*
* @param payload
* @param orgId
* @param callback
*/

class PaymentModeActions {
  createPaymentMode = (payload, callback) => action(paymentModeActionTypes.CREATE_PAYMENT_MODE.REQUEST, {
    payload,
    callback,
  });

  createPaymentModeLoading = (createPaymentModeLoading) => action(paymentModeActionTypes.CREATE_PAYMENT_MODE.LOADING, {
    createPaymentModeLoading,
  })

  updatePaymentMode = (payload, callback) => action(paymentModeActionTypes.UPDATE_PAYMENT_MODE.REQUEST, {
    payload,
    callback,
  });

  updatePaymentModeLoading = (updatePaymentModeLoading) => action(paymentModeActionTypes.UPDATE_PAYMENT_MODE.LOADING, {
    updatePaymentModeLoading,
  })

  /**
  *
  * @param payload
  * @param callback
  */
  getPaymentMode = (accountType, callback) => action(paymentModeActionTypes.GET_PAYMENT_MODES.REQUEST, {
    accountType, callback,
  })

  /**
  *
  * @return
  */
  getPaymentModeLoading = (getPaymentModeLoading) => action(paymentModeActionTypes.GET_PAYMENT_MODES.LOADING, {
    getPaymentModeLoading,
  })

  /**
  * @return
  */
  getPaymentModeSuccess = (paymentModeResults) => action(paymentModeActionTypes.GET_PAYMENT_MODES.SUCCESS, {
    paymentModeResults,
  })

  deletePaymentMode = (payload, callback) => action(paymentModeActionTypes.DELETE_PAYMENT_MODE.REQUEST, {
    payload,
    callback,
  });

  deletePaymentModeLoading = (deletePaymentModeLoading) => action(paymentModeActionTypes.DELETE_PAYMENT_MODE.LOADING, {
    deletePaymentModeLoading,
  })
}

export default new PaymentModeActions();
